import { usePocketSphinxWakeWord } from '../wake-word/useWakeWord';
import useSTT from './useSTT';

export const useSpeech = () => {
  usePocketSphinxWakeWord();
  useSTT();
};
